import React from "react";
import { Modal } from "react-bootstrap";

const Popup = ({
  show,
  onHide,
  title,
  content,
  size,
  position,
  onClickBtn1,
  btn1,
  btn2,
}) => {
  return (
    <Modal
      size={size ? size : "lg"}
      // data-bs-target='modal'
      aria-labelledby="contained-modal-title-vcenter"
      {...(position ? position : "centered")}
      show={show}
      onHide={onHide}
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{content}</Modal.Body>
      {btn1 && btn2 && <Modal.Footer>
        <div className="d-flex justify-content-center ">
          <div
            style={{
              cursor: "pointer",
              backgroundColor: "#1f7e78",
              color: "white",
              border: "1px solid #bbb9b9",
              height: "48px",
              width: "90px",
              float: "right",
            }}
            className="description_btnsave d-flex justify-content-center align-items-center"
            // data-bs-dismiss="modal"
            onClick={onClickBtn1}
          >
            {btn1}
          </div>
          <div
            style={{
              cursor: "pointer",
              backgroundColor: "#fff",
              color: "black",
              border: "1px solid #bbb9b9",
              height: "48px",
              width: "90px",
            }}
            onClick={onHide}
            className="description_btnsave d-flex justify-content-center align-items-center"
          >
            {btn2}
          </div>
        </div>
      </Modal.Footer>}
    </Modal>
  );
};

export default Popup;
